import Page from '../../../shared/components/Page/Page';
import {useEffect, useState} from "react";
import {Form, Table, Tag} from "antd";
import ReadMoreText from "../../../shared/components/ReadMoreText";
import {formatDateTime} from "../../../shared/utils/helpers";
import { getLogs } from "../api";
import Search from "../../../shared/components/Search/Search";
import dayjs from "dayjs";

const banks = [
    'MOMO', 'ACB', 'VTB', 'BIDV', 'MSB', 'MSB_DIGIBANK', 'TCB', 'VCB',
    'TECH_BUSINESS', 'VCB_BUSINESS', 'VIETTELPAY', 'VTB_BUSINESS', 'MB',
    'MB_BUSINESS', 'SAB', 'PGB', 'BVB', 'TIMO', 'EIB', 'NAB', 'TPB', 'OCB',
].map((bank) => ({value: bank, text: bank}));

function textOf(value) {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    return JSON.stringify(value);
}

function BankRequestLog() {
    const [tableLoading, setTableLoading] = useState(false);
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });

    const items = [
        {
            name: 'bankName',
            type: 'select',
            placeholder: 'Ngân hàng',
            options: banks,
        },
        {
            name: 'username',
            type: 'text',
            placeholder: 'Username',
        },
        {
            name: 'accountNumber',
            type: 'text',
            placeholder: 'Số tài khoản',
        },
        {
            name: 'statusCode',
            type: 'text',
            placeholder: 'Status code',
        },
        {
            name: 'url',
            type: 'text',
            placeholder: 'URL',
        },
        {
            name: 'createdAt',
            type: 'date',
        }
    ];

    const columns = [
        {
            title: 'Thời gian',
            dataIndex: 'createdAt',
            sorter: true,
            width: 170,
            render: (value) => formatDateTime(value)
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName',
            sorter: true,
            width: 140,
            render: (value) => <Tag>{value}</Tag>
        },
        {
            title: 'Username',
            dataIndex: 'username',
            sorter: true,
            width: 140,
        },
        {
            title: 'Số TK',
            dataIndex: 'accountNumber',
            sorter: true,
            width: 140,
        },
        {
            title: 'Method',
            dataIndex: 'method',
            sorter: true,
            width: 90,
            align: 'center',
            render: (value) => <Tag color="blue">{value}</Tag>
        },
        {
            title: 'URL',
            dataIndex: 'url',
            width: 280,
            render: (value) => <ReadMoreText text={textOf(value)} maxLength={80}/>
        },
        {
            title: 'Status',
            dataIndex: 'statusCode',
            sorter: true,
            width: 90,
            align: 'center',
            render: (value) => {
                if (value === null || value === undefined) {
                    return <Tag>-</Tag>
                }
                if (value >= 200 && value <= 299) {
                    return <Tag color="green">{value}</Tag>
                }
                return <Tag color="red">{value}</Tag>
            }
        },
        {
            title: 'ms',
            dataIndex: 'durationMs',
            sorter: true,
            width: 90,
            align: 'right',
        },
        {
            title: 'Lỗi',
            dataIndex: 'errorMessage',
            width: 220,
            render: (value) => <ReadMoreText text={textOf(value)} maxLength={80}/>
        },
        {
            title: 'Body gửi',
            dataIndex: 'requestBody',
            width: 260,
            render: (value) => <ReadMoreText text={textOf(value)} maxLength={80}/>
        },
        {
            title: 'Body nhận',
            dataIndex: 'responseBody',
            width: 260,
            render: (value) => <ReadMoreText text={textOf(value)} maxLength={80}/>
        },
        {
            title: 'Header gửi',
            dataIndex: 'requestHeaders',
            width: 220,
            render: (value) => <ReadMoreText text={textOf(value)} maxLength={80}/>
        },
        {
            title: 'Header nhận',
            dataIndex: 'responseHeaders',
            width: 220,
            render: (value) => <ReadMoreText text={textOf(value)} maxLength={80}/>
        },
    ];

    const fetchData = async () => {
        setTableLoading(true);
        const response = await getLogs( tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
        }
        setTableLoading(false);
    }

    const handleSearch = () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            pagination: {
                ...tableParams.pagination,
                current: 1,
            },
            search: {
                ...params
            }
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };

    useEffect(() => {
        fetchData().finally();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.sorter),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.search),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters),
    ]);

    return (
        <Page title="Log request ngân hàng">
            <Search
                form={form}
                items={items}
                onSearch={handleSearch}
            />
            <Table
                rowKey="logBankRequestId"
                columns={columns}
                dataSource={dataSource}
                bordered={true}
                onChange={handleTableChange}
                loading={tableLoading}
                pagination={tableParams.pagination}
                scroll={{
                    x: 2400,
                }}
            />
        </Page>
    )
}

export default BankRequestLog;
